import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';


// tag, metricLabel and result are admin:landing.cases.items.<id>.<field>.
const cases = [
    {
        id: 'fintech',
        company: 'SaaS Fintech',
        metric: '47',
        gradient: 'from-emerald-400 to-cyan-400',
    },
    {
        id: 'hrTech',
        company: 'HR Tech',
        metric: '68',
        gradient: 'from-purple-400 to-pink-400',
    },
    {
        id: 'cybersecurity',
        company: 'Cybersecurity',
        metric: '35',
        gradient: 'from-orange-400 to-red-400',
    },
];

export default function CasesSection() {
    const { t } = useTranslation(['admin']);
    return (
        <section id="cases" className="relative py-32 bg-[#0a0a0a]">
            {/* Gradient line */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            
            <div className="max-w-6xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-xs uppercase tracking-[0.2em] text-purple-400 mb-4 block">
                        {t('admin:landing.cases.label')}
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold text-white">
                        {t('admin:landing.cases.heading')}
                    </h2>
                </motion.div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                    {cases.map((caseStudy, index) => (
                        <motion.div
                            key={caseStudy.company}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.15 }}
                            className="group relative"
                        >
                            <div className="relative h-full p-6 md:p-8 rounded-3xl bg-white/[0.02] border border-white/[0.05] hover:border-white/10 transition-all overflow-hidden">
                                {/* Background glow */}
                                <div className={`absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br ${caseStudy.gradient} opacity-10 blur-3xl group-hover:opacity-20 transition-opacity`} />
                                
                                <div className="relative">
                                    {/* Header */}
                                    <div className="mb-8">
                                        <span className="text-xs font-medium px-2 py-1 rounded-full bg-white/5 text-white/50">
                                            {t(`admin:landing.cases.items.${caseStudy.id}.tag`)}
                                        </span>
                                        <h3 className="text-xl font-semibold text-white mt-3">{caseStudy.company}</h3>
                                    </div>

                                    {/* Big Metric */}
                                    <div className="mb-6">
                                        <span className={`text-5xl md:text-6xl font-bold bg-gradient-to-r ${caseStudy.gradient} bg-clip-text text-transparent`}>
                                            {caseStudy.metric}
                                        </span>
                                        <p className="text-sm text-white/40 mt-1">{t(`admin:landing.cases.items.${caseStudy.id}.metricLabel`)}</p>
                                    </div>

                                    {/* Result */}
                                    <div className="pt-6 border-t border-white/5">
                                        <p className="text-sm text-white/60">{t(`admin:landing.cases.items.${caseStudy.id}.result`)}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}